export enum SelectionMode {
	NONE,
	SINGLE,
	MULTIPLE,
	KEEPLAST
}
